import React, { useState } from 'react';
import { contacts } from 'src/common';
import { HelpOnboarding } from '../../assets/icons';
import { HelpImage } from 'src/assets/images';
import { Card } from '../';
import TealiumEvents from '../../helpers/tealium-events';
import MiniAppEvents from 'src/helpers/miniapp-events';
import toastMessageServiceSingleton from 'src/services/toast-message.service';
import './help-fab-onboarding.scss';

const copyTextToClipboard = (text) => {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  toastMessageServiceSingleton.addToast({
    message: `Copied to clipboard`,
    type: 'info',
  });
};

export default function HelpFloatingActionButtonOnboarding(props) {
  const [showHelp, setShowHelp] = useState(false);
  const inMiniProgram = MiniAppEvents.isInMiniApp();
  const helpPhoneUrl = contacts.numberUrl;
  const helpEmail = contacts.email;
  const helpEmailUrl = contacts.emailUrl;

  return (
    <div
      className={`${props.className || ''} HelpFloatingActionButtonOnboarding`}
      data-testid="HelpFloatingActionButton"
    >
      {showHelp && (
        <Card
          onClose={() => {
            setShowHelp(false);
          }}
        >
          <div className="container has-padding-x-2 has-mobile-padding-x-0">
            <div
              automationid="Help_Div_HelpOpen"
              className="has-padding-y-7 help-image has-mobile-padding-top-0"
            >
              <img src={HelpImage} alt="help" />
            </div>
            <div className="help-text">Need help? Get in touch with us:</div>
            <div className="link-container has-padding-x-7 has-padding-top-6 has-padding-bottom-0">
              <div>
                <a
                  className="help-link help-subtext"
                  href={helpPhoneUrl}
                  onClick={() => {
                    const url = window.location.href;
                    const urlSplit = url.split('/');
                    const lowestLevelPath = urlSplit[urlSplit.length - 1];
                    TealiumEvents.helpOnboardingSupportNumberClick(
                      helpPhoneUrl,
                      props.customerType,
                      lowestLevelPath,
                    );
                  }}
                >
                  {contacts.number}
                </a>
              </div>
              <div>
                {inMiniProgram && !MiniAppEvents.isAndroid() ? (
                  <span
                    className="help-link help-subtext break-text"
                    href={helpEmailUrl}
                    onClick={() => {
                      const url = window.location.href;
                      const urlSplit = url.split('/');
                      const lowestLevelPath = urlSplit[urlSplit.length - 1];
                      TealiumEvents.helpOnboardingEmailClick(
                        helpEmailUrl,
                        props.customerType,
                        lowestLevelPath,
                      );
                      copyTextToClipboard(helpEmail);
                    }}
                  >
                    {helpEmail}
                  </span>
                ) : (
                  <a
                    className="help-link help-subtext break-text"
                    href={helpEmailUrl}
                    onClick={() => {
                      const url = window.location.href;
                      const urlSplit = url.split('/');
                      const lowestLevelPath = urlSplit[urlSplit.length - 1];
                      TealiumEvents.helpOnboardingEmailClick(
                        helpEmailUrl,
                        props.customerType,
                        lowestLevelPath,
                      );
                    }}
                  >
                    {helpEmail}
                  </a>
                )}
              </div>
            </div>
          </div>
        </Card>
      )}
      <div
        className="is-pulled-right has-margin-top-3 has-mobile-margin-top-6 help-toggle"
        automationid="Help_Button_HelpOpen"
        onClick={() => {
          if (!showHelp) {
            const url = window.location.href;
            const urlSplit = url.split('/');
            const lowestLevelPath = urlSplit[urlSplit.length - 1];
            TealiumEvents.helpOnboardingOpenButtonClick(props.customerType, url, lowestLevelPath);
          }
          setShowHelp(!showHelp);
        }}
      >
        <HelpOnboarding className="is-clickable" open={showHelp} />
      </div>
    </div>
  );
}
